// React hook: load data from an API function and re-load on demand.
//   const { data, error, loading, reload } = useRpc("issues_get", { code, issue });
// Re-fetches whenever the arguments change (compared by JSON).
import { useCallback, useEffect, useState } from "react";
import { rpc } from "./backend";
import type { RpcMap, RpcName } from "./types";

export function useRpc<N extends RpcName>(fn: N, args: Record<string, unknown> = {}) {
  const key = JSON.stringify(args);
  const [state, setState] = useState<{ data: RpcMap[N] | null; error: string | null; loading: boolean }>(
    { data: null, error: null, loading: true });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    rpc(fn, JSON.parse(key))
      .then((data) => live && setState({ data, error: null, loading: false }))
      .catch((e: Error) => live && setState({ data: null, error: e.message, loading: false }));
    return () => { live = false; };
  }, [fn, key, tick]);
  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { ...state, reload };
}
